<template>
  <side-panel-inner
    on-close="AdminDeviceNotificationIndex"
    :headerTitle="headerTitle"
  >
    <template slot="actions" v-if="!loading">
      <base-button primary="true" @click="onSend" type="button" v-if="!isSent"
        >Send</base-button
      >
      <dropdown v-if="!isSent">
        <dropdown-action
          icon="save"
          :iconFill="false"
          @click="handleSubmit"
          v-if="!editMode"
          >Save</dropdown-action
        >
        <dropdown-action
          icon="save"
          :iconFill="false"
          @click="handleSubmit"
          v-if="editMode && !isSent"
          >Update</dropdown-action
        >
        <dropdown-action
          icon="cross"
          danger
          @click="onDelete"
          v-if="editMode && !isSent"
          >Delete</dropdown-action
        >
      </dropdown>
    </template>
    <loading v-if="loading" />

    <form v-else>
      <form-field
        label="Title"
        helper-text="A title for the notification, optional.  Please keep to 70 characters"
        show-counter
        :max-length="70"
        v-model="currentNotification.title"
        data-vv-as="title"
        id="title"
        name="title"
        v-validate="{ required: true }"
        full-width
        :error="errors.first('title')"
      />

      <form-field
        label="Notification body"
        helper-text="The body of the notification.  Try to keep short"
        v-model="currentNotification.body"
        full-width
        type="textarea"
        data-vv-as="body"
        id="body"
        name="body"
        v-validate="{ required: true }"
        :error="errors.first('body')"
      />

      <form-field
        label="Link to a resource?"
        helper-text="Specify if you want the notification to take the user to a specific part of the app"
      >
        <form-resource
          :showValidTick="false"
          :model="selectedResource"
          placeholder
          id="resource"
          name="resource"
          @change="onResourceChange"
      /></form-field>

      <form-radio
        label="Mandatory message?"
        helper_text="Specify if this message is mandatory or not.  Mandatory messages can not be ignored by the user"
        :options="`mandatory:Yes\nnot_mandatory:No`"
        :checked="mandatoryCheckedVal"
        @input="handleMandatoryChange"
        :disabled="mandatoryDisabled"
      />

      <form-radio
        label="Select audience"
        helper_text="Choose whether to send to everyone, or specify users"
        :options="audienceOptions"
        :checked="checkedVal"
        @input="handleAudienceChange"
      />

      <form-field
        v-if="showUserSelect"
        label="Select Users"
        name="audience"
        helper-text="Select users you want to send your message to"
      >
        <user-group-select
          @onChange="onUserAdd"
          v-model="currentNotification.users"
          :groups-permission="[
            'collaboration_manager',
            'collaboration_manager_plus',
          ]"
          :ad-permission="['collaboration_manager_plus']"
          :user-permission="[
            'collaboration_manager',
            'collaboration_manager_plus',
          ]"
          data-vv-as="users"
          id="users"
          name="users"
          v-validate="{ required: true }"
          :error="errors.first('users')"
        />
      </form-field>
    </form>
  </side-panel-inner>
</template>
<script>
import { mapState } from "vuex";
import { UserGroupSelect } from "@/components/forms";
import Pagination from "@/components/pagination";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Dropdown from "@/components/Dropdown";
import DropdownAction from "@/components/DropdownAction";
import FormResource from "@/components/FormResource";
import UserHasPermission from "@/mixins/UserHasPermission";

export default {
  name: "DeviceNotificationAdminAddEdit",

  mixins: [UserHasPermission],

  components: {
    Pagination,
    VuetablePagination,
    UserGroupSelect,
    Dropdown,
    DropdownAction,
    FormResource,
  },

  methods: {
    onResourceChange(resource) {
      console.log(
        "🚀 ~ file: AddEdit.vue ~ line 150 ~ onResourceChange ~ resource",
        resource
      );
      const parsed = JSON.parse(resource);
      if (parsed.type == "page") {
        this.currentNotification.resource_id = parsed.pageId;
        this.currentNotification.resource_class = "content_page";
      } else {
        this.currentNotification.resource_id = null;
        this.currentNotification.resource_class = null;
      }
    },
    onUserAdd(value) {
      if (value == null || value.length < 1) {
        this.selected_users = [];
        this.currentNotification.users = [];
        this.currentNotification.mandatory = false;
        this.mandatoryCheckedVal = "not_mandatory";
        this.mandatoryDisabled = false;
        return;
      }
      // if selecting a group, we need to make the question mandatory
      this.selected_users = [];
      // TODO: Do we do this just for groups or for individual users too?
      // this.currentNotification.users = value.map((val) => val.id);
      if (value.id && value.id.includes("grp_")) {
        this.currentNotification.mandatory = true;
        this.mandatoryCheckedVal = "mandatory";
        this.mandatoryDisabled = true;
      } else {
        this.currentNotification.mandatory = false;
        this.mandatoryCheckedVal = "not_mandatory";
        this.mandatoryDisabled = false;
      }

      // yep values as well
      value.forEach((val) => {
        //if we are a group, we need to extract the individual user ids
        if (val.id.toString().includes("grp")) {
          val = val.meta.data;
          this.currentNotification.users = [
            ...this.currentNotification.users,
            ...val,
          ];
        } else {
          this.currentNotification.users.push(val.id);
        }
        this.selected_users.push(val);
      });
    },

    onDelete() {
      const vm = this;
      this.$store.dispatch("createDialog", {
        // TODO: This does the right thing, but do we need to create its own
        // method in the store so we can alter the confirmation etc.?
        confirm: () => {
          this.$store
            .dispatch("DeviceNotifications/delete", vm.currentNotification.id)
            .then((resp) => {
              this.$router.push({
                name: "AdminDeviceNotificationIndex",
              });
              this.$store.dispatch("notifications/create", {
                body: `The notification was deleted`,
                type: "success",
              });
            });
        },
      });
    },
    onSend() {
      const vm = this;
      // validate first
      this.$validator.validate().then((result) => {
        if (!result) {
        } else {
          this.$store.dispatch("createDialog", {
            // TODO: This does the right thing, but do we need to create its own
            // method in the store so we can alter the confirmation etc.?
            confirm: async () => {
              // if there is no ID, we need to save first
              if (!vm.currentNotification.id) {
                const resp = await vm.$store.dispatch(
                  `DeviceNotifications/create`
                );
                vm.currentNotification.id = resp.id;
              }
              this.$store
                .dispatch("DeviceNotifications/send", vm.currentNotification.id)
                .then((resp) => {
                  this.$router.push({
                    name: "AdminDeviceNotificationIndex",
                  });
                  this.$store.dispatch("notifications/create", {
                    body: `The notification has been scheduled to send`,
                    type: "success",
                  });
                });
            },
          });
        }
      });
    },

    handleAudienceChange(val) {
      this.showUserSelect = val == "specify";
    },
    handleMandatoryChange(val) {
      this.currentNotification.mandatory = val == "mandatory";
    },
    handleSubmit() {
      this.loading = true;

      const vm = this;
      this.$validator.validate().then((result) => {
        if (!result) {
          this.loading = false;
          vm.showValidationMessage = true;
        } else {
          //need to make sure user ids are just user ids
          if (this.currentNotification.users.length > 0) {
            this.currentNotification.users = this.currentNotification.users.map(
              (usr) => (usr.id ? usr.id : usr)
            );
          }
          const action = vm.editMode ? "update" : "create";

          vm.$store
            .dispatch(`DeviceNotifications/${action}`)
            .then((resp) => {
              this.$store.dispatch("notifications/create", {
                body: `The notification was ${
                  vm.editMode ? "updated" : "created"
                }`,
                type: "success",
              });
              if (!vm.editMode) {
                vm.$router.push({
                  name: "AdminNotificationEdit",
                  params: { id: resp.id },
                });
              } else {
                vm.loadNotification(vm.$route.params.id);
              }
            })
            .catch((err) => {
              console.log(
                "🚀 ~ file: AddEdit.vue ~ line 128 ~ this.$validator.validate ~ err",
                err
              );
              vm.loading = false;
              //error - try to display here
              this.$store.dispatch("notifications/create", {
                body: `The notification was not ${
                  vm.editMode ? "updated" : "created"
                }`,
                type: "error",
              });
            });
        }
      });
    },
    checkIfShowUsers() {
      if (!this.isInGroup("comms_team")) {
        this.checkedVal = "specify";
        this.showUserSelect = true;
      }
    },
    loadNotification(id) {
      this.$store
        .dispatch("DeviceNotifications/read", id)
        .then(() => {
          if (this.currentNotification.users.length > 0) {
            this.checkedVal = "specify";
            this.showUserSelect = true;
          }
          // resource?
          if (this.currentNotification.resource) {
            const { resource } = this.currentNotification
            /**
             * '{"id":"/test-page-for-the-app/breadcrumb-test","pageId":1350,"name":"Breadcrumb test","type":"page"}',
             */
            this.selectedResource = JSON.stringify({
              id: resource.slug,
              pageId: resource.id,
              name: resource.title,
              type: 'page'
            })
          }
          this.loading = false;
          this.editMode = true;
          this.checkIfShowUsers();
        })
        .catch((err) => {
          this.loading = false;
          this.showError = true;
        });
    },
  },
  data() {
    return {
      editMode: false,
      loading: true,
      showError: false,
      showUserSelect: false,
      checkedVal: "all",
      showMandatorySelect: false,
      mandatoryCheckedVal: "not_mandatory",
      mandatoryDisabled: false,
      selected_users: [],
      selectedResource: null
    };
  },

  computed: {
    ...mapState("DeviceNotifications", [
      "currentNotification",
      "notifications",
    ]),
    isSent() {
      return this.currentNotification.status == "sent";
    },
    headerTitle() {
      return `${this.editMode ? "Edit" : "Create"} Notification`;
    },
    // If the user is collab or collab plus, they can send to groups
    // comms teams can only send to people
    audienceOptions() {
      if (this.isInGroup("comms_team")) {
        return `all:Send to all\nspecify:Specify users`;
      }
      return "specify:Specify users";
    },
  },
  mounted() {
    if (!this.$route.params.id) {
      // this.$store.dispatch('Banner')
      this.$store
        .dispatch("DeviceNotifications/getBaseNotification")
        .then((resp) => {
          this.checkIfShowUsers();
          this.loading = false;
        });
    } else {
      this.loadNotification(this.$route.params.id);
    }
  },
};
</script>

<style lang="scss" scoped></style>
